export default {
  group: {
    feed: {
      notes: 'Label for feed group in screen response diagram',
      message: 'Feed',
    },
    diagonal: {
      notes: 'Label for diagonal group in screen response diagram',
      message: 'Diagonal',
    },
    discharge: {
      notes: 'Label for discharge group in screen response diagram',
      message: 'Discharge',
    },
    center: {
      notes: 'Label for center group in screen response diagram',
      message: 'Center',
    },
  },
};
